import { cloneDeep, merge } from 'lodash-es';

import { DEFAULT_REGISTER_FORM } from '@/components/attend-meeting/entry-form/data';

const state = {
	registerForm: cloneDeep(DEFAULT_REGISTER_FORM)
};

const mutations = {
	SET_FORM_DATA(state, data) {
		console.log('🚀 ~ SET_FORM_DATA ~ data:', data);
		// 对于数组类型的字段，直接替换而不是合并
		const mergedData = { ...state.registerForm };
		Object.keys(data).forEach(key => {
			if (Array.isArray(data[key])) {
				mergedData[key] = [...data[key]];
			} else if (typeof data[key] === 'object' && data[key] !== null) {
				mergedData[key] = { ...mergedData[key], ...data[key] };
			} else {
				mergedData[key] = data[key];
			}
		});
		console.log('🚀 ~ SET_FORM_DATA ~ mergedData:', mergedData);
		state.registerForm = mergedData;
	},
	SET_FORM_FIELD(state, { field, value }) {
		// 支持嵌套字段更新，如 'businessCard.imageUrl'
		const fieldPath = field.split('.');
		let current = state.registerForm;

		for (let i = 0; i < fieldPath.length - 1; i++) {
			const key = fieldPath[i];
			if (!current[key]) {
				current[key] = {};
			}
			current = current[key];
		}

		const lastKey = fieldPath[fieldPath.length - 1];
		current[lastKey] = value;
	},
	RESET_FORM(state) {
		state.registerForm = cloneDeep(DEFAULT_REGISTER_FORM);
	}
};

const actions = {
	setFormData({ commit }, data) {
		commit('SET_FORM_DATA', data);
	},
	setFormField({ commit }, { field, value }) {
		commit('SET_FORM_FIELD', { field, value });
	},
	resetForm({ commit }) {
		commit('RESET_FORM');
	}
};

const getters = {
	registerForm: state => state.registerForm
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
